/**
 * Action buttons — mirror Access toolbar row T=3756 (Refresh, Save, Load, Unallocate, Clean).
 *
 * Rendered inline as the `rightSlot` of the FilterBar trong StockSalesDataGrid để
 * dồn title + filter + action vào cùng một hàng, tiết kiệm chiều dọc.
 */
import { Stack, Button, Box } from '@mui/material'
import { HIDE_ON_MOBILE_INLINE } from '@/theme/responsive'
import RefreshIcon from '@mui/icons-material/Refresh'
import SaveIcon from '@mui/icons-material/Save'
import FolderOpenIcon from '@mui/icons-material/FolderOpen'
import LinkOffIcon from '@mui/icons-material/LinkOff'
import ClearAllIcon from '@mui/icons-material/ClearAll'

interface Props {
  canEdit: boolean
  hasSelectedRow: boolean
  isEditing: boolean
  isSaving: boolean
  isDeleting: boolean
  onClean: () => void
  onLoad: () => void
  onSave: () => void
  onRefresh: () => void
  onDelete: () => void
}

const actionBtnSx = {
  minWidth: 0,
  px: 1.1,
  py: 0.3,
  minHeight: 28,
  fontSize: '0.72rem',
  lineHeight: 1.1,
  textTransform: 'none' as const,
  fontWeight: 600,
  '& .MuiButton-startIcon': { mr: 0.5 },
  '& .MuiButton-startIcon > svg': { fontSize: 16 },
}

export default function ActionToolbar({
  canEdit,
  hasSelectedRow,
  isEditing,
  isSaving,
  isDeleting,
  onClean,
  onLoad,
  onSave,
  onRefresh,
  onDelete,
}: Props) {
  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={0.5}
      useFlexGap
      flexWrap="wrap"
      sx={{ flexShrink: 0 }}
    >
      <Button
        variant="outlined"
        size="small"
        startIcon={<RefreshIcon />}
        onClick={onRefresh}
        disabled={isSaving || isDeleting}
        title="Refresh"
        sx={actionBtnSx}
      >
        <Box component="span" sx={HIDE_ON_MOBILE_INLINE}>Refresh</Box>
      </Button>
      <Button
        variant="contained"
        color="primary"
        size="small"
        startIcon={<SaveIcon />}
        onClick={onSave}
        disabled={!canEdit || isSaving || isDeleting}
        sx={actionBtnSx}
      >
        Save
      </Button>
      <Button
        variant="contained"
        size="small"
        startIcon={<FolderOpenIcon />}
        onClick={onLoad}
        disabled={!hasSelectedRow || isSaving || isDeleting}
        title="Load"
        sx={actionBtnSx}
      >
        <Box component="span" sx={HIDE_ON_MOBILE_INLINE}>Load</Box>
      </Button>
      <Button
        variant="outlined"
        color="error"
        size="small"
        startIcon={<LinkOffIcon />}
        onClick={onDelete}
        disabled={!canEdit || !isEditing || isSaving || isDeleting}
        title="Unallocate"
        sx={actionBtnSx}
      >
        <Box component="span" sx={HIDE_ON_MOBILE_INLINE}>Unallocate</Box>
      </Button>
      <Button
        variant="outlined"
        size="small"
        startIcon={<ClearAllIcon />}
        onClick={onClean}
        title="Clean"
        sx={actionBtnSx}
      >
        <Box component="span" sx={HIDE_ON_MOBILE_INLINE}>Clean</Box>
      </Button>
    </Stack>
  )
}
